import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid, makeStyles, Paper, Typography,
} from '@material-ui/core'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { orange } from '@material-ui/core/colors'
import {
  withStyles,
} from '@material-ui/core/styles'
import FormStep from './FormStep'

const OrangeCheckbox = withStyles({
  root: {
    color: orange[400],
    '&$checked': {
      color: orange[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />)

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 1, 0, 1),
  },
  legal: {
    maxHeight: theme.spacing(30),
    overflow: 'auto',
    marginTop: theme.spacing(2.5),
    padding: theme.spacing(2.5),
    textAlign: 'justify',
    whiteSpace: 'pre-line',
  },
  acceptRoles: {
    marginTop: theme.spacing(2),
  },
  labelAcceptRoles: {
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '3rem',
  },
  buttonNext: {
    width: theme.spacing(20),
  },
}))

const RolesStep = ({ setActiveStep, steps }) => {
  const classes = useStyles()
  const rolesRef = React.useRef()
  const [acceptRoles, setAcceptRoles] = useState(false)
  const [readRoles, setReadRoles] = useState(false)
  const handleScroll = (e) => {
    const element = e.target
    if (element.scrollHeight - Math.round(element.scrollTop) === element.clientHeight) {
      setReadRoles(true)
    }
  }

  React.useEffect(() => {
    const { current } = rolesRef
    const hasScroll = current.scrollHeight > current.clientHeight
    if (!hasScroll) {
      setReadRoles(true)
    }
  }, [])

  const handleChange = () => {
    setAcceptRoles(!acceptRoles)
  }

  const handleClick = () => {
    setActiveStep(steps[FormStep.name])
  }

  return (
    <Grid item xs={12} classes={{ root: classes.root }}>
      <Paper>
        <Typography
          classes={{ root: classes.legal }}
          variant="body1"
          onScroll={handleScroll}
          ref={rolesRef}
        >
          تا حالا به شما گفتند که در وجود شما
          استعداد خاصی هست که در دیگران نیست؟ مثلاً شما صدای بسیار
          خوبی دارید، یا توانایی بسیاری خوبی در نوشتن دارید و یا حتی قدرت
          بالایی در محاسبه ذهنی دارید که می‌تواند هر فردی را شگفت‌زده کند.
          <br />
          اگر جز این افراد هستید و فکر می‌کنید استعداد و توانمندی خاصی دارید که نیاز به
          حمایت و دیده‌شدن دارد، گارنت به‌عنوان دوست و همراه در کنار شماست.
          <br />
          از استعداد و توانمندی خاص خود فیلم‌برداری کنید و ویدئو را در آپلود کنید.
          <br />
          در زمان فیلم‌برداری برداری حتماً این نکات را رعایت کنید:
          <br />
          <br />
          &#9899; در ابتدای ویدئو بعد از معرفی خود بگوید: این ویدئو جهت بورسیه گارنت تهیه شده است.
          <br />
          &#9899; ویدئو دارای کیفیت مناسب صدا و تصویر باشد.
          <br />
          &#9899; حداکثر مدت‌زمان ویدئو 5 دقیقه باشد.
          <br />
          &#9899; تصاویر را به‌صورت افقی ضبط کنید.
          <br />
          &#9899; موازین اخلاقی و شرعی را در تهیه ویدئو رعایت کنید.
          <br />
          &#9899; قبل از آپلود ویدئو فرم مربوط به بورسیه
          و قوانین شرکت در بورسیه را بادقت مطالعه کنید.

        </Typography>
      </Paper>
      <FormControlLabel
        classes={{ root: classes.acceptRoles, label: classes.labelAcceptRoles }}
        control={(
          <OrangeCheckbox
            color="primary"
            name="acceptRoles"
            checked={acceptRoles}
            onChange={handleChange}
            disabled={!readRoles}
          />
              )}
        label="تمامی موارد را میپذیرم"
        labelPlacement="end"
      />
      <Grid classes={{ root: classes.buttonContainer }}>
        <Button
          variant="contained"
          color="primary"
          classes={{ root: classes.buttonNext }}
          size="large"
          disabled={!acceptRoles}
          onClick={handleClick}
        >
          مرحله بعد
        </Button>
      </Grid>
    </Grid>
  )
}

RolesStep.propTypes = {
  setActiveStep: PropTypes.func,
  steps: PropTypes.object,
}

export default RolesStep
